/** Must match API default ENV PLATFORM_OPS_EMAIL */
export const PLATFORM_OPS_EMAIL = "cs@airon.no";

/** True only when session email equals {@link PLATFORM_OPS_EMAIL} (case-insensitive). */
export function isPlatformOpsUser(email: string | undefined | null): boolean {
  return (email || "").trim().toLowerCase() === PLATFORM_OPS_EMAIL.toLowerCase();
}
